import React from 'react'
import cx from "classnames";
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import PaymentMethodSkeleton from '../PaymentMethodSkeleton/PaymentMethodSkeleton'
import s from './PriceDetailsSkeleton.css'

function PriceDetailsSkeleton() {
    return (
        <div>
            <div className={s.priceDetailsSkeletonBox}>
                <Skeleton className={s.priceDetailsSkeletonTitle} />
                <div>
                    {[1, 2, 3].map((n) => {
                        return (
                            <div key={n} className={s.priceDetailsSkeletonAmountWrapper}>
                                <div className={s.priceDetailsSkeletonAmountTitleContainer}>
                                    <Skeleton className={cx(s.priceDetailsSkeletonDesc, n === 1 ? s.priceDetailsSkeletonAmountTitle : s[`priceDetailsSkeletonAmountTitleDesc${n}`])} />
                                </div>
                                <div className={s.priceDetailsSkeletonAmountContainer}>
                                    <Skeleton className={cx(s.priceDetailsSkeletonDesc, n === 1 ? s.priceDetailsSkeletonAmount : s[`priceDetailsSkeletonAmountDesc${n}`])} />
                                </div>
                            </div>
                        )
                    })}
                </div>
                <hr className={s.priceDetailsSkeletonDivider} />
                <div className={s.priceDetailsSkeletonAmountWrapper}>
                    <div className={s.priceDetailsSkeletonAmountTitleContainer}>
                        <Skeleton className={cx(s.priceDetailsSkeletonDesc, s.priceDetailsSkeletonTotalAmountTitle)} />
                    </div>
                    <div className={s.priceDetailsSkeletonAmountContainer}>
                        <Skeleton className={cx(s.priceDetailsSkeletonDesc, s.priceDetailsSkeletonAmount)} />
                    </div>
                </div>
            </div>
            <PaymentMethodSkeleton />
        </div>
    )
}

export default withStyles(s)(PriceDetailsSkeleton);

